export enum GeometryType {
  Point = 'Point',
}
